// Safe fallback = production browse base, matching legacy behavior when the
// backend-provided base (AppContext.jiraBrowseBase, derived from JSM_DOMAIN) is
// unavailable. Pass the runtime base so links match the active instance.
const DEFAULT_JIRA_BROWSE_BASE = 'https://globe-sav.atlassian.net/browse';

export const getJiraIssueUrl = (issueKey: string, browseBase?: string | null): string =>
  `${browseBase || DEFAULT_JIRA_BROWSE_BASE}/${issueKey}`;
